import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_192_vendor_bill_allocations: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "193",
      action: "navigate_modulev1/vendor_bill_allocations",
    },
    title: "Vendor bill wise allocation",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "name",
            Name: "vendor_bill_allocations_summary",
            BindValue: "grid_vendor_bill_allocations",
            SummeryActions: [
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "supplier_paid_amount_splitup",
                },
                tooltip: "View",
              },
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Settings: "supplier_statementof_accounts",
                },
                tooltip: "Statement of accounts",
              },
            ],
            Form: {
              Name: "vendor_bill_allocations_summary",
              TableName: "",
              View: "view_vendor_bill_allocation_list",
              DisplayName: "vendor_bill_allocations_summary",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "suppliername",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor address",
                  BindValue: "address",
                  Json_Attribute: "address",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
